(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('errorModal', errorModal);

    /* @ngInject */
    function errorModal() {
        var directive = {
            bindToController: true,
            templateUrl: 'error-modal.tpl',
            controller: errorModalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            //console.log(scope.vm.data);
        }
    }

    /* @ngInject */
    function errorModalController ($scope) {
        $scope.close = function() {
            angular.element('.overlay.active').removeClass('active');
        };
    }
})();